import { Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
// import { theme } from '../../../provider/ThemeProvider'
import { nl2br } from "../../../utils/nl2br";

type TableProps = {
  rows: {title:string, value?:string | React.ReactNode}[];
  hover?:boolean;
  width?: string | number ;
  small?: boolean;
};

export const HeadlessTable= (props: TableProps) => {
  const { rows, hover, width, small } = props;
  return (
    <Table>
      <TableBody style={{border: "1px solid  rgba(224, 224, 224, 1)"}}>
        {rows.map((row, index) => {
          return (
            <TableRow hover={hover} role='checkbox' tabIndex={-1} key={index}>
              <CustomizedTitle width={width}>{row.title}</CustomizedTitle>
              <CustomizedTableCell small={small}>{nl2br(row.value)}</CustomizedTableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};


interface MultiColmunsTableProps {
  headers: string[];
  rows: string[][];
  small?: boolean;
  lang: "en" | "ja"
}

/**
 * 複数列のテーブルを作成する
 * @param headers ヘッダー　配列の先頭は空白
 * @param rows 行　配列の先頭はタイトル
 * @param lang 選択している言語
 */
export const SleepGudelineTable: React.FC<MultiColmunsTableProps> = ({
  headers,
  rows,
  small,
  lang
}) => {
  return (
    <StyledTableContainer>
      <CustomizedTable aria-label="custom table">
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <CustomizedTableHeadCell  align="center" key={index} isTitle={index === 0}>{header}</CustomizedTableHeadCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {row.map((cell , cellIndex) => (
                <StyledTableCell small={small} key={cellIndex} isTitle={cellIndex === 0} lang={lang}>{cell}</StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </CustomizedTable>
    </StyledTableContainer>
  );
};

type CustomizedTitleProps = {
  width?: string | number;
}

const CustomizedTitle = styled(TableCell)<CustomizedTitleProps>(({ width = '65%' }) => ({
  fontSize: '14px', // 16pxから14pxに縮小
  marginLeft: '8px',
  background: "#F2F2F2",
  width: width,
  fontFamily: 'ABeeZee',
  '@media print': {
    fontSize: '12px', // 印刷時はさらに小さく
  }
}));

const CustomizedTableCell = styled(TableCell)<{small?: boolean}>(({small})=>({
  padding: small ? '4px 8px' : '12px 16px',
  wordBreak: "break-all",
  fontFamily: 'ABeeZee',
  fontSize: '13px', // フォントサイズを追加
  '@media print': {
    padding: small ? '2px 4px' : '12px 16px',
    fontSize: '11px', // 印刷時は小さく
  }
}));



const CustomizedTable = styled(Table)({
  minWidth: 500,
  '& th': {
    border: '1px solid rgba(224, 224, 224, 1)',
    fontWeight: 'bold',
  },
  '& td': {
    border: '1px solid rgba(224, 224, 224, 1)',
    whiteSpace: 'pre-wrap'
  },
  '& tr:first-child th': {
    maxWidth: '15rem',
    minWidth: '4rem',
  },
  '& tr:last-child td': {
  },
  '& tr td:first-child': {
    maxWidth: '15rem',
    minWidth: '4rem',
  },
  '& tr td:last-child': {
  },
});

const CustomizedTableHeadCell = styled(TableCell)<{isTitle?: boolean}>(({isTitle})=>({
  background: "#E7F3FB",
  fontSize:'12px', // 14pxから12pxに縮小
  padding:'4px',
  width: isTitle? '200px' : 'auto',
  '@media print': {
    fontSize: '10px', // 印刷時はさらに小さく
  }
}));

const StyledTableCell = styled(TableCell)<{isTitle?: boolean, small?: boolean, lang: "en" | "ja"}>`
  background-color: ${(({isTitle})=> isTitle?'#F7F5F5' : '#FFF')};
  font-size: ${(({small, lang})=> {
    if(lang === "ja") {
      return small ? "11px":"13px" // 13px/15pxから11px/13pxに縮小
    }
    return small ? "9px": "11px" // 11px/13pxから9px/11pxに縮小
  })};
  padding: 4px 8px;
  width: ${(({isTitle})=> isTitle? '200px' : 'auto')};
  box-sizing: border-box;
  @media print {
    padding: 4px 8px;
    max-width: 30%;
    font-size: ${(({small, lang})=> {
    if(lang === "ja") {
      return small ? "10px":"12px" // 12px/15pxから10px/12pxに縮小
    }
    return small ? "8px": "10px" // 11px/13pxから8px/10pxに縮小
  })};
  }
`

const StyledTableContainer = styled(TableContainer)`
  @media print {
    .MuiTable-root {
      min-width: auto;
    }
  }
`